import { Box, clickableStyle, CrudMode, getSpacing, Grid, ListContext, PAGE_DEFAULT, PAGE_SIZE_UNLIMITED, Stack, Typography, useElementBreakpoints } from "@compass/core";
import { FileTypeCategory, Permission, StudentServiceEditResource, StudentServiceFile, StudentServiceListFilter } from "generated/openApi";
import "moment-timezone";
import FileUploadRoundedIcon from "@mui/icons-material/FileUploadRounded";
import { Outlet, useNavigate } from "react-router-dom";
import { useList, useRouter } from "hooks";
import { FileListItem } from "pages/students/student-applications/StudentApplicationPage/FileList/FileListItem";
import { useEffect, useState } from "react";
import ApiService from "services/apiService";
import { FileDetail } from "pages/students/student-applications/StudentApplicationPage/FileDetail/FileDetailComponent";

export const ServiceFiles = (props: {
  crudMode: CrudMode;
  rootPermission: Permission;
  editResource: StudentServiceEditResource;
  id: number;
  serviceFiles: StudentServiceFile[];
  setServiceFiles: (value: StudentServiceFile[]) => void;
}) => {
  const { breakpointsRef, smallFieldBreakpoints } = useElementBreakpoints();
  const navigate = useNavigate();
  const { matchTemplatePath } = useRouter();
  const [files, setFiles] = useState<StudentServiceFile[]>();
  const [modalOpen, setModalOpen] = useState(false);

  const [listFilter, setListFilter] = useState<StudentServiceListFilter>({
    page: PAGE_DEFAULT,
    pageSize: PAGE_SIZE_UNLIMITED,
  });

  const renderFileItem = (file: StudentServiceFile, fileIndex: number) => {

    return (
      <FileListItem file={file} index={fileIndex} fileCategory={file.fileCategory?.name} />
    );
  };

  // const { tableContainerRef, loadList } = useList({
  //   listFilter: listFilter,
  //   setListFilter: setListFilter,
  //   fetchList: (listFilter) => {
  //     ApiService.studentServices.getStudentServiceFiles(props.id).then((response) => {
  //       setFiles(response);
  //     });
  //   },
  // });

  // useEffect(() => {
  //   if (props.id) {
  //     ApiService.studentServices.getStudentServiceFiles(props.id).then((response) => {
  //       setFiles(response);
  //     });
  //   }
  // }, [props.id]);

  return (
    <>
      <Grid ref={breakpointsRef} container spacing="sm">
        {props.serviceFiles?.map((file, fileIndex) => renderFileItem(file, fileIndex))}

        {props.crudMode == "edit" && (<Grid item xs={smallFieldBreakpoints}>
          <Box
            position="relative"
            p={getSpacing("sm")}
            overflow="hidden" // need this for ellipsis to work?
            sx={{
              border: (theme) => `1px solid ${theme.palette.border.dark}`,
              pointerEvents: "auto",
              opacity: 1,
            }}
          >
            <Stack
              position="relative"
              direction="row"
              justifyContent={"center"}
              alignItems={"center"}
              sx={{ height: "42px", ...clickableStyle, opacity: "0.7" }}
              onClick={() =>
                setModalOpen(true)
                // navigate({
                //   pathname: fileDetailPageRoute.getPath({
                //     fileType: FileTypeCategory.StudentServiceFile,
                //     screenType: "dialog",
                //     crudMode: "edit",
                //     parentEntityId: props.id,
                //     entityId: 0,
                //   }),
                // })
              }
            >
              <FileUploadRoundedIcon />
              <Typography>Add File</Typography>
            </Stack>
          </Box>
        </Grid>)}
      </Grid>

      <FileDetail
        fileType={FileTypeCategory.StudentServiceFile}
        open={modalOpen}
        crudMode="edit"
        screenType="dialog"
        parentEntityId={props.id}
        entityId={0}
        onChange={(file) => {
          setModalOpen(false);
          props.setServiceFiles([...props.serviceFiles, file as StudentServiceFile])
        }}
      />

      {/* <ListContext.Provider value={{ loadList: (options) => loadList(listFilter, { resetPage: options?.resetPage }) }}>
        {matchTemplatePath(fileDetailPageRoute.templatePath) && <Outlet />}
      </ListContext.Provider> */}
    </>
  );
};
